let scrollInput;
const r = new rive.Rive({
  src: "https://cdn.shopify.com/s/files/1/0726/7015/0901/files/kaleng.riv?v=1744171581",
  canvas: document.getElementById("canvas"),
  stateMachines: "State Machine 1",
  artboard: "Artboard",
  autoplay: true,
  layout: new rive.Layout({
    fit: rive.Fit.FitWidth,
    alignment: rive.Alignment.CenterLeft,
  }),
  onLoad: () => {
    // Ambil input bernama "angka"
    const inputs = r.stateMachineInputs("State Machine 1");
    scrollInput = inputs.find((input) => input.name === "angka");
  },
});

const body = document.querySelector("body");
const bodyParent = body.parentNode;
const pageLength = bodyParent.scrollHeight;
const pctLabel = document.getElementById("pctLabel");
document.onscroll = () => {
  const scrollOffset = bodyParent.scrollTop;
  const scrollPctValue =
    (100 * scrollOffset) / (pageLength - bodyParent.clientHeight);
  const mappedScroll = ((scrollPctValue - 35) / (45 - 35)) * 100;
  const clampedScroll = Math.min(Math.max(mappedScroll, 0), 100);

  // Update nilai input "angka" di Rive
  if (scrollInput) {
    scrollInput.value = clampedScroll;
  }
};